import baseLayout from '@/layout/Layout.vue';

export default {
  base: baseLayout,
};
